import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useDispatch } from "react-redux";
import { openEinvoicePreview, openPreviewNew } from "../../../../store/actions/detailsDocument/preview";

export const DocPreview = ({ newDetail, setPreviewModal, einvoiceType }) => {
  const dispatch = useDispatch();

  const openPreview = (documentId, factType) => {
    /**
     * La preview viene gestita come segue:
     * factType === INVOICE | RECEIPT -> si chiama la preview del b2b-read
     * factType === BANK_TRANSACTION -> nessuna preview
     * factType === DOCUMENT -> preview pdc-server-api
     */
    setPreviewModal(true);
    if (factType === "INVOICE" || factType === "RECEIPT"){
      dispatch(openEinvoicePreview(documentId, einvoiceType)).then(res => {
        if (res) {

        }
      }).catch( err => {
        console.log("Error preview");
      });

    } else if (factType === "DOCUMENT"){
      dispatch(openPreviewNew(
        documentId,
        1,
        false
      )).then(res => {
        if (res) {
          setPreviewModal(true);
        }
      }).catch( err => {
        console.log("Error preview");
      });
    }

  };

  return (
    <div>
      <div onClick={() => openPreview(newDetail?.doc?.id, newDetail?.factType)}
        style={{ display: "flex", alignItems: "center", padding: "0 16px", cursor: "pointer" }}>
        <FontAwesomeIcon icon={["far", "eye"]} className="pre-cog-detail-header-preview" />
      </div>
    </div>
  );
};
